// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"bbad49be","247":"d731de1d","488":"54b21f48","627":"5b586d73","653":"51ab66b4","834":"10bc317d","867":"dca8381b","923":"cd787bbb","938":"1708327d"}[chunkId] + ".chunk.js";
};